export enum State {
    PREMIUM = 'PREMIUM',
    BASIC = 'BASIC',
    FREE = 'FREE',
    PREVIEW = 'PREVIEW',
    DEMO = 'DEMO',
    LITE = 'LITE'
}
